import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "./NavbarM.css";
import { menuItems } from "../constants";
import { FaHamburger } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const NavbarM = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHamburgerOpened, setHamburgerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const currentIndex = menuItems.findIndex((item) => item.path === location.pathname);
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
    }
  }, [location.pathname]);

  const handleMenuClick = (index) => {
    setActiveIndex(index);
  };

  const handleMobileMenuClick = () => {
    setHamburgerOpen(!isHamburgerOpened);
    console.log("opened=" + isHamburgerOpened);
  };

  return (
    <>
      <div className="navigation">
        <ul>
          {menuItems.map((item, index) => (
            <li
              key={index}
              className={`list ${activeIndex === index ? "active" : ""}`}
              onClick={() => handleMenuClick(index)}
            >
              <Link to={item.path} className="cursor-pointer">
                <span className="icon">{item.icon}</span>
                <span className="text">{item.text}</span>
                <span className="circle"></span>
              </Link>
            </li>
          ))}
          <div
            className="indicator"
            style={{ transform: `translateX(calc(70px * ${activeIndex}))` }}
          ></div>
        </ul>
      </div>
      <div className="mobile-menu-container">
        <div className="mobile-navbar">
          <span className="hamburger-icon" onClick={() => handleMobileMenuClick()}>
            {!isHamburgerOpened ? <FaHamburger /> : <IoMdClose />}
          </span>
        </div>
        <div className={`mobile-list ${isHamburgerOpened ? "open" : ""}`}>
          <ul>
            {menuItems.map((item, index) => (
              <li>
                <Link
                  to={item.path}
                  className="cursor-pointer flex flex-row justify-end p-2"
                  onClick={handleMobileMenuClick}
                >
                  <span>{item.icon}</span>
                  <span className="pl-2">{item.text}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavbarM;
